import React from 'react'
import {connect} from 'react-redux'
import {getCategory,setShowCategory,setShowSeries,getSeries,getParts,setShowPart,setShowPartner,getAllPartner} from '../../containers/app/actions'
import ConfCategory from '../Category/confCategory/ConfCategory'
import ConfPartner from '../Partner/confPartner/ConfPartner'
import ConfParts from '../Parts/confParts/ConfParts'
import ConfSeries from '../Series/confSeries/ConfSeries'
import Snackbar from '../utils/snackbar/Snackbar'

const CombineComp = (props) => {
    const [catModal,setCatModal] = React.useState(false)
    const [seriesModal,setSeriesModal] = React.useState(false)
    const [partModal,setPartModal] = React.useState(false)
    const [partnerModal,setPartnerModal] = React.useState(false)

    const [alert,setAlert] = React.useState(false);

    React.useEffect(() => {
        setCatModal(props.showAddCategory);
    },[props.showAddCategory]);

    React.useEffect(() => {
        setSeriesModal(props.showAddSeries);
    },[props.showAddSeries]);

    React.useEffect(() => {
        setPartModal(props.showAddPart);
    },[props.showAddPart]);

    React.useEffect(() => {
        setPartnerModal(props.showAddPartner);
    },[props.showAddPartner]);

    return (
    <React.Fragment> 
        {catModal && <ConfCategory 
            type="ADD" 
            open={catModal} 
            onClose={() => props.setShowCategory(false)} 
            onDone={() => {
                props.setShowCategory(false)
                props.getCategory(props.user._id,"SET_ACTIVE")

                //props.setActiveCategory()
            }}
            setAlert={(msg) => setAlert(msg)}
        />}


        {seriesModal && <ConfSeries
            type="ADD" 
            open={seriesModal} 
            onClose={() => props.setShowSeries(false)} 
            onDone={() => {
                props.setShowSeries(false)
                props.getSeries(props.user._id,"SET_ACTIVE")
            }}
            setAlert={(msg) => setAlert(msg)}
        />}

        {partModal && <ConfParts
            type="ADD" 
            open={partModal} 
            onClose={() => props.setShowPart(false)} 
            onDone={() => {
                props.setShowPart(false)
                props.getParts(props.user._id,"SET_ACTIVE")
            }}
            setAlert={(msg) => setAlert(msg)}
        />}

        {partnerModal && <ConfPartner
            type="ADD" 
            open={partnerModal} 
            onClose={() => props.setShowPartner(false)} 
            onDone={() => {
                props.setShowPartner(false)
                props.getAllPartner(props.user._id,"SET_ACTIVE")
            }}
            setAlert={(msg) => setAlert(msg)}
        />}

        <Snackbar open={alert} handleClose={() => setAlert(false)}/>

    </React.Fragment>
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user,
    showAddCategory: state.appReducer.showAddCategory,
    showAddSeries: state.appReducer.showAddSeries,
    showAddPart: state.appReducer.showAddPart,
    showAddPartner: state.appReducer.showAddPartner
})

export default connect(mapStateToProps,{getCategory,setShowCategory,setShowSeries,getSeries,setShowPart,getParts,setShowPartner,getAllPartner})(CombineComp);